import { useRef, useState } from "react";
import { api } from "../../lib/api";

const ADDR = ["street", "district", "city", "state"];
const onlyDigits = (s) => (s || "").replace(/\D/g, "");
export const maskCep = (v) => { const d = onlyDigits(v).slice(0, 8); return d.length > 5 ? `${d.slice(0, 5)}-${d.slice(5)}` : d; };

// CEP lookup: fills only empty or previously auto-filled fields; stale answers are ignored.
export function useCep(token, setForm) {
  const seq = useRef(0);
  const auto = useRef({});
  const [st, setSt] = useState({ state: "idle" });
  const apply = (found) => {
    setForm((f) => {
      const next = { ...f };
      ADDR.forEach((k) => { const was = auto.current[k]; if (!f[k] || f[k] === was) next[k] = found?.[k] || ""; });
      return next;
    });
    auto.current = Object.fromEntries(ADDR.map((k) => [k, found?.[k] || ""]));
  };
  const lookup = async (zip) => {
    const d = onlyDigits(zip);
    const n = ++seq.current;
    if (d.length !== 8) { setSt({ state: "idle" }); return; }
    setSt({ state: "loading", zip: d });
    try {
      const { data } = await api.get(`/public/admission/${token}/cep/${d}`);
      if (n !== seq.current) return;
      apply(data.found ? data : null);
      setSt({ state: data.found ? "ok" : "notfound", zip: d });
      if (data.found) setTimeout(() => document.querySelector(`[data-testid="${data.street ? "cand-number" : "cand-street"}"]`)?.focus(), 60);
    } catch { if (n === seq.current) setSt({ state: "error", zip: d }); }
  };
  return { st, lookup, retry: () => lookup(st.zip) };
}

const MSG = { loading: ["Consultando CEP...", "text-slate-500"], ok: ["Endereço preenchido pelo CEP. Confira e informe o número.", "text-emerald-700"],
  notfound: ["CEP não encontrado. Preencha o endereço manualmente.", "text-amber-700"], error: ["Não foi possível consultar o CEP agora. Preencha manualmente ou tente de novo.", "text-amber-700"] };

export const CepStatus = ({ st, retry }) => (st.state === "idle" ? null : (
  <div className={`flex items-center gap-2 text-xs ${MSG[st.state][1]}`} data-testid="cand-cep-status" data-state={st.state}>
    {MSG[st.state][0]}{st.state === "error" && <button type="button" className="font-semibold underline" onClick={retry} data-testid="cand-cep-retry">Tentar novamente</button>}
  </div>));
